import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { estimateTemplateEndpoints } from '@/lib/api/endpoints';
import { estimateTemplateKeys } from '@/lib/queryKeys';
import type { EstimateTemplate, CreateEstimateTemplateDto } from '@/types/estimateTemplate';

/**
 * Creates a new estimate template via the operations microservice.
 */
export const useCreateEstimateTemplate = createMutationHook<
  EstimateTemplate,
  CreateEstimateTemplateDto
>({
  mutationFn: (dto) =>
    apiPost<EstimateTemplate, CreateEstimateTemplateDto>(
      operationsClient,
      estimateTemplateEndpoints.create(),
      dto,
    ),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: estimateTemplateKeys.lists() });
    toast.success('Estimate template created');
  },
});
